var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSolv = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24Z",
    fill: "#7667EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7129 24C46.7129 11.4559 36.5441 1.28711 24 1.28711C11.4559 1.28711 1.28711 11.4559 1.28711 24C1.28711 36.5441 11.4559 46.7129 24 46.7129V48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48V46.7129C36.5441 46.7129 46.7129 36.5441 46.7129 24Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2219,
    y: 7.07431,
    width: 4.38255,
    height: 19.7207,
    rx: 2.19128,
    transform: "rotate(45 24.2219 7.07431)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.4815,
    y: 14.8635,
    width: 4.38255,
    height: 19.7207,
    rx: 2.19128,
    transform: "rotate(45 25.4815 14.8635)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2442,
    y: 16.1415,
    width: 4.38255,
    height: 19.7207,
    rx: 2.19128,
    transform: "rotate(45 33.2442 16.1415)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5038,
    y: 23.9307,
    width: 4.38255,
    height: 19.7207,
    rx: 2.19128,
    transform: "rotate(45 34.5038 23.9307)",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSolv);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/solv.0fc746c3bd5098dcf0d4564e347096dc.svg";